"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Field = void 0;

var _react = _interopRequireWildcard(require("react"));

var _formContext = require("./form-context");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Field = function Field(PassedComponent) {
  var passedProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var FieldComponent = function FieldComponent(fieldProps) // Exclude<P, FieldPassedProps> & FieldPassedProps
  {
    var api = (0, _react.useContext)(_formContext.ContextApi);
    var groupName = (0, _react.useContext)(_formContext.ContextFieldGroup);
    (0, _react.useContext)(_formContext.ContextForm);

    if (!api) {
      console.error("Could not found Form API. Make sure <".concat(PassedComponent.displayName || PassedComponent.name, "/> is in the <Form/>."));
      return null;
    }

    var _fieldProps$passedPro = _objectSpread({}, fieldProps, {}, passedProps),
        name = _fieldProps$passedPro.name,
        className = _fieldProps$passedPro.className,
        hideError = _fieldProps$passedPro.hideError,
        disabled = _fieldProps$passedPro.disabled,
        props = _objectWithoutProperties(_fieldProps$passedPro, ["name", "className", "hideError", "disabled"]);

    (0, _react.useEffect)(function () {
      if (groupName) {
        api.addFieldToGroup(groupName, name);
      }

      return function () {
        if (groupName) {
          api.removeFieldFromGroup(groupName, name);
        }
      };
    }, [name]);
    (0, _react.useEffect)(function () {
      if (disabled) {
        api.setDisabled(name);
      } else {
        api.removeDisabled(name);
      }
    }, [disabled]);
    var errors = api.getErrors(name);
    var classNames = className ? [className] : [];

    var _api$getClasses = api.getClasses('field'),
        invalidClassName = _api$getClasses.invalid,
        errorClassName = _api$getClasses.error;

    if (errors && errors.length > 0 && invalidClassName) {
      classNames.push(invalidClassName);
    }

    return _react["default"].createElement(_react.Fragment, null, _react["default"].createElement(PassedComponent, _extends({}, props, {
      name: name,
      disabled: disabled,
      className: classNames.join(' '),
      getValue: function getValue() {
        return api.getValue(name);
      },
      getErrors: function getErrors() {
        return api.getErrors(name);
      },
      setValue: function setValue(value, callback) {
        return api.setValue(name, value, callback);
      },
      setTouched: function setTouched(callback) {
        return api.setTouched(name, callback);
      }
    })), !hideError && errors && errors.length > 0 ? _react["default"].createElement("div", {
      className: errorClassName
    }, Array.isArray(errors) ? errors[0] : errors) : null);
  };

  return FieldComponent;
};

exports.Field = Field;